module.exports = __webpack_public_path__ + "img/login_bg.101c5117.jpg";